var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPackaging(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_66013_52814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.98162 8.60305C1.78509 8.72113 1.62238 8.88795 1.50926 9.08737C1.39614 9.28679 1.33644 9.51204 1.33594 9.74131V11.898C1.33644 12.1273 1.39614 12.3525 1.50926 12.5519C1.62238 12.7514 1.78509 12.9182 1.98162 13.0363L3.97856 14.2344C4.18561 14.3588 4.42262 14.4245 4.66417 14.4245C4.90573 14.4245 5.14273 14.3588 5.34979 14.2344L7.99241 12.6502V8.98913L4.66417 6.99219L1.98162 8.60305Z",
    stroke: "black",
    strokeWidth: 0.998471,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66298 10.983L1.50781 9.08594",
    stroke: "black",
    strokeWidth: 0.998471,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66406 10.9813L7.9923 8.98438",
    stroke: "black",
    strokeWidth: 0.998471,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66406 10.9922V14.4336",
    stroke: "black",
    strokeWidth: 0.998471,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99219 8.98913V12.6502L10.6348 14.2344C10.8419 14.3588 11.0789 14.4245 11.3204 14.4245C11.562 14.4245 11.799 14.3588 12.006 14.2344L14.003 13.0363C14.1995 12.9182 14.3622 12.7514 14.4753 12.5519C14.5885 12.3525 14.6482 12.1273 14.6487 11.898V9.74131C14.6482 9.51204 14.5885 9.28679 14.4753 9.08737C14.3622 8.88795 14.1995 8.72113 14.003 8.60305L11.3204 6.99219L7.99219 8.98913Z",
    stroke: "black",
    strokeWidth: 0.998471,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3204 10.9813L7.99219 8.98438",
    stroke: "black",
    strokeWidth: 0.998471,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3203 10.983L14.4755 9.08594",
    stroke: "black",
    strokeWidth: 0.998471,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3203 10.9922V14.4336",
    stroke: "black",
    strokeWidth: 0.998471,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.30974 2.93516C5.11321 3.05323 4.95051 3.22006 4.83739 3.41948C4.72427 3.6189 4.66456 3.84415 4.66406 4.07342V6.9823L7.9923 8.97924L11.3205 6.9823V4.07342C11.32 3.84415 11.2603 3.6189 11.1472 3.41948C11.0341 3.22006 10.8714 3.05323 10.6749 2.93516L8.67791 1.737C8.47085 1.6126 8.23385 1.54687 7.9923 1.54688C7.75074 1.54688 7.51374 1.6126 7.30668 1.737L5.30974 2.93516Z",
    stroke: "black",
    strokeWidth: 0.998471,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9911 5.32678L4.83594 3.42969",
    stroke: "black",
    strokeWidth: 0.998471,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99219 5.32678L11.1474 3.42969",
    stroke: "black",
    strokeWidth: 0.998471,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99219 8.98918V5.32812",
    stroke: "black",
    strokeWidth: 0.998471,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_66013_52814"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9755,
    height: 15.9755,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackaging);
export default __webpack_public_path__ + "static/media/packaging.28d76be76ab128392cd5ea9bb5817230.svg";
export { ForwardRef as ReactComponent };